export const TANK_COATING_TYPES = ['Epoxy', 'Hempel Hempadur Phenolic Epoxy',
    'Jotun Primastic Unversal Alu Red Toned', 'Jotun Universal Alu Turquoise',
    'Korepox / Eh 2350', 'Marine Line', 'Marine Line 784 (Advanced Polymer Coating)',
    'Phenolic Epoxy', 'Stainless Steel', 'Zinc'];

export const HEATING_MEDIUM = ['Water', 'Steam', 'Thermal Oil'];

export const IGS_TYPES = ['Flue gas', 'Inert gas (IG) generator', 'Nitrogen'];

export const iceClassNames = [null, 'fitted', '1AS', '1A', '1B', '1C', '1D'];
export const ventilationNames = ['Electrical', 'Natural'];
export const imoAppNames = [
    'Appendix a', 'Appendix b', 'Appendix c', 
    'Appendix a, b', 'Appendix a, c', 'Appendix b, c',
    'Appendix a, b, c',
];
export const imoClassNames = [
    '1', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6',
    '2', '2.1', '2.2', '2.3',
    '3',
    '4', '4.1', '4.2', '4.3',
    '5', '5.1', '5.2',
    '6', '6.1', '6.2',
    '7', '8', '9',
];

export const ventilationOptions = [
    { value: 'electrical', label: 'Electrical' },
    { value: 'natural', label: 'Natural' },
];

export const fitted = {
    co2Fitted: 'co2Fitted',
    a60BulkheadFitted: 'a60BulkheadFitted',
    newPanama: 'newPanama',
    cementHolesFitted: 'cementHolesFitted',
    referPlugFitted: 'referPlugFitted',
    itfFitted: 'itfFitted',
    lakesFitted: 'lakesFitted',
    strengthenHeavy: 'strengthenHeavy',
    logsFitted: 'logsFitted',
    aussieFitted: 'aussieFitted',
    ventilation: 'ventilation',
    ventilationFitted: 'ventilationFitted',
    imoFitted: 'imoFitted',
    bwts: 'bwts',
    coiled: 'coiled',
    containerFitted: 'containerFitted',
    carFitted: 'carFitted',
    rampway: 'rampway',
    grainFitted: 'grainFitted',
    cargoTankDryer: 'cargoTankDryer',
    cargoCoolingSystem: 'cargoCoolingSystem',
    crudeOilWashing: 'crudeOilWashing',
    rcttms: 'rcttms',
    rctpms: 'rctpms',
    bowChainStopper: 'bowChainStopper',
    ngs: 'ngs',
    vrs: 'vrs',
    bowThruster: 'bowThruster',
    stemThruster: 'stemThruster',
    scrubberFitted: 'scrubberFitted',
    igsFitted: 'igs.fitted',
    boxShaped: 'boxShaped',
    openHatch: 'openHatch',
};



// WEBPACK FOOTER //
// ./app/constants/vesselRequirements.js